import * as React from "react";

/**
 * Below this the header's labelled buttons drop to icons. The pane IS the viewport, so a
 * media query measures the pane.
 */
const COMPACT_QUERY = "(max-width: 339px)";

/**
 * True while the pane is narrow enough that header actions should be icons only.
 *
 * A hook rather than a CSS breakpoint because the compact form changes the tooltip and
 * the accessible name, not just the look. jsdom has no matchMedia, so under Jest it is
 * never compact -- tests see the labelled buttons, as they did with MUI's useMediaQuery.
 */
export const useCompactPane = (): boolean => {
  const subscribe = React.useCallback((onChange: () => void) => {
    if (typeof window.matchMedia !== "function") return () => undefined;
    const list = window.matchMedia(COMPACT_QUERY);
    list.addEventListener("change", onChange);
    return () => list.removeEventListener("change", onChange);
  }, []);
  return React.useSyncExternalStore(
    subscribe,
    () => typeof window.matchMedia === "function" && window.matchMedia(COMPACT_QUERY).matches,
    () => false
  );
};
